import * as React from 'react';
import { LinkProps } from 'react-router-dom';
import { TextLink } from './ClickableText';
import { FeatherIcon } from './FeatherIcon';

export const BackLink: React.FC<LinkProps> = ({ children, ...props }) => {
  return (
    <TextLink {...props}>
      <FeatherIcon icon="arrow-left" className="h-4 w-4 mr-1 inline" />
      <span className="text-sm">{children}</span>
    </TextLink>
  );
};
